import { gql } from '__generated__';

export default gql(`
  mutation EditOrderFromBackend($input: EditOrderInput!) {
    editOrder(input: $input) {
      id
      participant_fields {
        ...OrderParticipantFieldFields
      }
      participant_field_entries {
        ...OrderParticipantFieldEntryFields
      }
      stand_alone_upgrades {
        id
        product {
          id
          title
        }
        promotion {
          id
          title
        }
        product_variant {
          id
          title
        }
        participant_fields {
          ...ParticipantFieldFields
        }
        participant_field_entries {
          ...ParticipantFieldEntryFields
        }
      }
    }
  }
`);
